import { FC, useState } from 'react';
import { Popover, Tooltip } from 'antd';
import useCommentReactions from 'src/hooks/useComments';
import { TbMoodPlus } from 'react-icons/tb';
import { Reaction } from 'src/utils/reaction';
import { EmojiPicker } from '../EmojiPicker';

interface CommentReactionOptionsProps {
  data: any;
  onAddReaction: (reaction: Reaction) => void;
  onRemoveReaction: (reaction: Reaction) => void;
  onVisibleChange?: (visible: boolean) => void;
  alwaysShow?: boolean;
}

const CommentReactionOptions: FC<CommentReactionOptionsProps> = ({
  data,
  onAddReaction,
  onRemoveReaction,
  onVisibleChange,
  alwaysShow,
}) => {
  const { addReact, removeReact, hasUserReaction } = useCommentReactions({
    initialData: data,
    onReactAdd: onAddReaction,
    onReactRemove: onRemoveReaction,
  });

  const [showPopover, setShowPopover] = useState(false);

  const handleVisibleChange = (v: boolean) => {
    setShowPopover(v);
    onVisibleChange?.(v);
  };

  const handleReactionToggle = (emojiId: string) => {
    if (hasUserReaction(emojiId)) {
      removeReact(emojiId);
    } else {
      addReact(emojiId);
    }
  };

  const popoverContent = (
    <div ref={(ref) => {
      if (ref) ref.onclick = (e) => e.stopPropagation();
    }}>
      <EmojiPicker
        onSelect={(emoji) => {
          handleReactionToggle(emoji.id);
          setShowPopover(false);
          onVisibleChange?.(false);
        }}
      />
    </div>
  );

  return (
    <div
      className={`reaction-container ${
        showPopover || alwaysShow ? '' : 'action-hover-container'
      }`}
    >
      <Popover
        placement="bottom"
        content={popoverContent}
        overlayClassName="no-padding-popover"
        trigger="click"
        open={showPopover}
        onOpenChange={handleVisibleChange}
      >
        <Tooltip title="Add reaction">
          <button type="button" className="action-bar-icon-button">
            <TbMoodPlus size={20} />
          </button>
        </Tooltip>
      </Popover>
    </div>
  );
};

export default CommentReactionOptions;
